import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';

// Components
import { FixedTable } from 'components/content-containers/tables';
import Return from './return';


// Component
export default function Returns({ purchaseOrder }) {
  const returns = _.filter(_.orderBy(purchaseOrder.expenseBills, bill => moment(bill.date).toDate(), 'desc'), 'returnFor');

  if (!returns.length) return null;

  return (
    <FixedTable
      className="returns"
      invisibleHeaders={[
        'col-expense-button',
        'col-duration',
        'col-money',
        'col-money',
        '',
        'col-small'
      ]}
      headerRow={
        <tr><th colSpan="6">Returns</th></tr>
      }
    >
      {_.map(returns, (expenseBillReturn) =>
        <Return expenseBillReturn={expenseBillReturn} purchaseOrder={purchaseOrder} key={expenseBillReturn.id} updatePurchaseOrder={purchaseOrder.update} />
      )}
    </FixedTable>
  );
}

Returns.propTypes = {
  purchaseOrder: PropTypes.object.isRequired
};
